import React, { useState } from 'react';
import RelativePortal from '../../corecomponents/Portal/RelativePortal';
import useHasMounted from '../../hooks/useHasMounted';
import OverflowMenu, { IOverflowMenuProps } from './OverflowMenu';

const MENU_WIDTH = 200;

interface IHoverOverflowMenuProps extends IOverflowMenuProps {
  menuHeader: any;
  ssr: boolean;
  portalId: string;
}

const HoverOverflowMenu: React.FC<IHoverOverflowMenuProps> = ({
  menuItems = [],
  menuHeader = <></>,
  ssr = false,
  portalId,
  ...props
}) => {
  const [active, setActive] = useState(false);

  const hasMounted = useHasMounted();

  const handleMouseEnter = () => {
    setActive(true);
  };

  const handleMouseLeave = () => {
    setActive(false);
  };

  const handleTouchEnd = e => {
    if (!e.cancelable) {
      return;
    }

    e.preventDefault();

    setActive(!active);
  };

  const portalProps = {
    component: 'div',
    active,
    width: MENU_WIDTH,
    additionalOffset: { top: -10, left: -10 },
    portalId
  };

  // The empty fragment prevents the OverflowMenu from using it's default children
  const overflowMenu = (
    <OverflowMenu
      $width={`${MENU_WIDTH}px`}
      isIntrinsiclyPositioned={false}
      menuItems={menuItems}
      alwaysShow
      {...props}
    >
      {null}
    </OverflowMenu>
  );

  let content = (
    // @ts-ignore
    <RelativePortal {...portalProps}>{overflowMenu}</RelativePortal>
  );

  if (ssr && !hasMounted) {
    // @ts-ignore
    content = <div css="display: none">{overflowMenu}</div>;
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div onTouchEnd={handleTouchEnd}>{menuHeader}</div>
      <div>{content}</div>
    </div>
  );
};

export default HoverOverflowMenu;
